import { useState, useEffect } from "@discovery/common-dplus/lib/hooks";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Favorites from "@discovery/sonic-api-ng/lib/api/users/favorites";
import { cn } from "@discovery/classnames";
import { pushFavoriteOrWatchListEvents } from "@discovery/common-dplus/lib/adobe";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import Strings from "../../../utils/hardcoded.json";
import { useUser } from "../../../utils/hooks/useUser";
import { useWindowSize } from "../../../utils/hooks";
import { navigateTo } from "../../../utils/common";
import { SHARE_TYPE, shareHandler } from "../../../utils/share";
import { Icon, Icons } from "../../atoms/icon";
import { HeaderVariants, Tags, Typography } from "../../atoms/typography";
import { Button, ButtonVariant } from "../../atoms/button";
import { Toast } from "../toast";
import { favorite } from "../favorites";
import { Share } from "../share";
import * as styles from "./styles.css";
import { setAuthRedirectUrl } from "../../../utils/authUrl";
export const LikeShare = ({ id, type, name, route, isFavorite, read, genre, anonymous, isFavPage, webAuthUrl, image, descriptionM, removeFromfavorites, isVideoPage = false, }) => {
    const [width] = useWindowSize();
    const { userId } = useUser();
    const shareUrl = config.shareBaseURL;
    const [isToastMsg, showToastMsg] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [successFlag, setSuccessFlag] = useState(false);
    const [isFav, toggleIsFav] = useState(false);
    const [isOnHover, setHoverAction] = useState(false);
    useEffect(() => {
        toggleIsFav(isFavorite);
    }, [isFavorite, id]);
    const toastHandler = (message, successFlag) => {
        setToastMessage(message);
        showToastMsg(true);
        setSuccessFlag(successFlag);
        setTimeout(() => {
            showToastMsg(false);
        }, 2000);
    };
    const toggleToast = () => {
        showToastMsg(false);
    };
    const toggleFavorite = (isFav, id) => {
        const videoType = type === "show" || type === "shows" ? type : "video";
        const authUrl = webAuthUrl + "/login";
        if (id) {
            if (anonymous) {
                const authRedirect = setAuthRedirectUrl(window.location.pathname);
                navigateTo(`${authUrl}?returnUrl=${authRedirect}`);
            }
            else {
                !isFavPage && toggleIsFav(!isFav);
                isFavPage
                    ? removeFromFavorites(id, videoType)
                    : read &&
                        favorite(userId, !isFav, read, id, videoType, toastHandler, route, false, name, genre);
            }
        }
    };
    const removeFromFavorites = (id, videoType) => {
        const postRequest = Favorites.Endpoints.deleteFavorite(id, `${videoType}`);
        read &&
            App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
                () => setToastMessage(Strings.ERROR_SAVING_PREFERENCE);
            }, () => {
                toastHandler("Removed from your Favourites", true);
                removeFromfavorites && removeFromfavorites(id);
                pushFavoriteOrWatchListEvents("remove favorites", "remove favorites", window.location.href, window.location.origin + route);
            }));
    };
    const FavoriteElement = () => (React.createElement(Button, { customstyle: cn(styles.likeShareButtonWrapper, {
            [styles.videoPageWrapper]: isVideoPage,
        }), variant: ButtonVariant.Rectangle, onClickM: M.of(() => toggleFavorite(isFav, id)), children: React.createElement(React.Fragment, null,
            React.createElement(Icon, { className: styles.favoriteIcon, type: isFav ? Icons.Favorite : Icons.UnFavorite, color: isOnHover ? "#ffffff" : isFav ? "#ffffff" : "#838991" }),
            React.createElement(Typography, { classNameM: M.of(cn(styles.linkLabel, {
                    [styles.active]: isFav,
                    [styles.videoPageLabel]: isVideoPage,
                })), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                React.createElement(React.Fragment, null, Strings.FAVORITE))) }));
    const ShareElement = () => {
        const mobileShareHandler = M.of(() => shareHandler(SHARE_TYPE.SHARE, image, descriptionM, name, shareUrl + route));
        const desktopShareHandler = M.of(() => { });
        const handleShare = width >= 700 ? desktopShareHandler : mobileShareHandler;
        return (React.createElement(Button, { onClickM: handleShare, customstyle: cn(styles.likeShareButtonWrapper, {
                [styles.videoPageWrapper]: isVideoPage,
            }), variant: ButtonVariant.Rectangle, children: React.createElement(React.Fragment, null,
                React.createElement(Icon, { className: styles.shareIcon, type: Icons.ShareIcon, color: "white" }),
                React.createElement(Typography, { classNameM: M.of(cn(styles.linkLabel, { [styles.videoPageLabel]: isVideoPage })), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, Strings.SHARE)),
                width >= 700 && (React.createElement("div", { className: styles.desktopShareWrapper },
                    React.createElement(Share, { title: name, setToastMsg: toastHandler, image: image, descriptionM: descriptionM, type: type, route: route })))) }));
    };
    const handleMouseEnter = () => {
        setHoverAction(true);
    };
    const handleMouseLeave = () => {
        setHoverAction(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { onMouseEnter: () => handleMouseEnter(), onMouseLeave: handleMouseLeave, className: styles.main, id: isFav ? "favoriteButton" : "unFavoriteButton" },
                React.createElement(FavoriteElement, null)),
            React.createElement("div", { className: styles.container, id: "share" },
                React.createElement(ShareElement, null))),
        isToastMsg ? (React.createElement(Toast, { toastMsg: toastMessage, successFlag: successFlag, onClick: toggleToast })) : null));
};

